import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import "./RichTextEditor.css";

const DEFAULT_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["blockquote", "link"],
    ["clean"],
  ],
};

const DEFAULT_FORMATS = [
  "header", "bold", "italic", "underline", "strike",
  "color", "background", "list", "align", "blockquote", "link",
];

export default function RichTextEditor({ value, onChange, readOnly = false, placeholder, testId, minHeight = 220 }) {
  return (
    <div className="rich-text-wrap" data-testid={testId} style={{ "--rte-min-h": `${minHeight}px` }}>
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={(v) => onChange && onChange(v)}
        readOnly={readOnly}
        placeholder={placeholder}
        modules={DEFAULT_MODULES}
        formats={DEFAULT_FORMATS}
      />
    </div>
  );
}
